module.exports = __webpack_public_path__ + "static/media/fizz.6d392aa2.png";